import { Loader2 } from "lucide-react";
import { FormModal } from "@/components/shared";

/**
 * Consent dialog shown before capturing a user's delegated token for
 * background/scheduled workflow access. Extracted from
 * `ScheduledFlowAuthControl` so the control stays focused on status logic.
 */
export function BackgroundAccessConsentModal({
  busy,
  onCancel,
  onConfirm,
  message,
}: Readonly<{ busy: boolean; onCancel: () => void; onConfirm: () => void; message?: React.ReactNode }>) {
  return (
    <FormModal
      title="Authorize background access"
      loading={busy}
      maxWidth="max-w-lg"
      onClose={() => !busy && onCancel()}
      onSubmit={(e) => {
        e.preventDefault();
        onConfirm();
      }}
      footer={
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="px-4 py-2 text-sm font-medium text-content-secondary hover:bg-interactive-hover rounded-lg disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={busy}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-brand-primary hover:bg-brand-primary/90 rounded-lg disabled:opacity-50"
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            Authorize
          </button>
        </div>
      }
    >
      <div className="space-y-3 text-sm text-content-secondary">
        {message ?? (
          <p>
            When this workflow runs on a schedule, Anthm will act on your behalf using your Microsoft permissions — for
            example, reading your Outlook mail or SharePoint files that a step requests. Anthm will not gain access to
            anything you cannot already access.
          </p>
        )}
        <p>
          This stays on until you turn it off. If it goes unused for 60 days, you'll be asked to re-authorize. You can
          revoke it at any time from your account settings.
        </p>
      </div>
    </FormModal>
  );
}
